module.exports = __webpack_public_path__ + "assets/images/amountofPaintings-01.fe573c300d36ccb05470d62326c0fc12.svg";